"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RetirementIncomeRefineModal;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _RetirementIncomeGapModalFormControls = require("./RetirementIncomeGapModalFormControls");
var _PopoverAndOverlay = require("../Wizard/PopoverAndOverlay");
var _RetirementIncomeGapWizardCalc = require("./RetirementIncomeGapWizardCalc.config");
var _RetirementIncomeGapHousingModal = _interopRequireDefault(require("./RetirementIncomeGapHousingModal"));
var _RetirementIncomeGapGroceriesModal = _interopRequireDefault(require("./RetirementIncomeGapGroceriesModal"));
var _RetirementIncomeGapHealthcareModal = _interopRequireDefault(require("./RetirementIncomeGapHealthcareModal"));
var _RetirementIncomeGapTransportationModal = _interopRequireDefault(require("./RetirementIncomeGapTransportationModal"));
var _RetirementIncomeGapTravelModal = _interopRequireDefault(require("./RetirementIncomeGapTravelModal"));
var _RetirementIncomeGapPersonalModal = _interopRequireDefault(require("./RetirementIncomeGapPersonalModal"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var _utils = require("../../middleware/utils");
var _RetirementIncomeGapWizardCalcConfig = require("./RetirementIncomeGapWizardCalc.config.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function RetirementIncomeRefineModal(props) {
  var {
    handleClose,
    snapshot,
    show,
    setValidationData,
    setSnapshot,
    currentExpenses,
    setCurrentExpenses,
    futureExpenses,
    setFutureExpenses
  } = props;

  // Pulling formik context from higher up, which gives us access to formik state
  var {
    errors,
    touched,
    setFieldValue,
    values,
    isSubmitting,
    isValid
  } = (0, _formik.useFormikContext)();
  var ageDifference = parseInt(values.retirementAge) - parseInt(values.currentAge);
  (0, _react.useEffect)(() => {
    if (values.housing_modalHasBeenOpened === false) {
      setFieldValue('housing_otherExpenses', values.housingAndInsuranceCost || '0');
    }
    if (values.healthcare_modalHasBeenOpened === false) {
      setFieldValue('healthcare_otherExpenses', values.healthcareAndInsuranceCost || '0');
    }
    if (values.transportation_modalHasBeenOpened === false) {
      setFieldValue('transportation_otherExpenses', values.transportationAndInsuranceCost || '0');
    }
    if (values.groceries_modalHasOpened === false) {
      setFieldValue('groceries_otherFoodExpenses', values.groceriesAndDiningOutCost || '0');
    }
    if (values.travel_modalHasBeenOpened === false) {
      setFieldValue('travel_otherTravelEntertainmentExpenses', values.travelAndEntertainmentCost || '0');
    }
    if (values.personal_modalHasBeenOpened === false) {
      setFieldValue('personal_otherPersonalExpenses', values.personalAndMiscellaneousCost || '0');
    }
    setCurrentExpenses(sumCurrentExpenses());
  }, [values.housingAndInsuranceCost, values.healthcareAndInsuranceCost, values.transportationAndInsuranceCost, values.groceriesAndDiningOutCost, values.travelAndEntertainmentCost, values.personalAndMiscellaneousCost]);
  function sumCurrentExpenses() {
    return 0 + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.housingAndInsuranceCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.healthcareAndInsuranceCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.transportationAndInsuranceCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.groceriesAndDiningOutCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.travelAndEntertainmentCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.personalAndMiscellaneousCost));
  }

  // Future Value useEffect
  (0, _react.useEffect)(() => {
    setFutureExpenses(sumFutureExpenses());
  }, [values.futureInflated_housingAndInsuranceCost, values.futureInflated_healthcareAndInsuranceCost, values.futureInflated_transportationAndInsuranceCost, values.futureInflated_groceriesAndDiningOutCost, values.futureInflated_travelAndEntertainmentCost, values.futureInflated_personalAndMiscellaneousCost]);
  (0, _react.useEffect)(() => {
    setFieldValue('futureInflated_housingAndInsuranceCost', futureValue(values.future_housingAndInsuranceCost, ageDifference, (0, _utils.parseFloatCurrencyString)(null, values.housingExpenses)));
    setFieldValue('futureInflated_healthcareAndInsuranceCost', futureValue(values.future_healthcareAndInsuranceCost, ageDifference, (0, _utils.parseFloatCurrencyString)(null, values.healthCareAndInsuranceExpenses)));
    setFieldValue('futureInflated_transportationAndInsuranceCost', futureValue(values.future_transportationAndInsuranceCost, ageDifference, (0, _utils.parseFloatCurrencyString)(null, values.transportationExpenses)));
    setFieldValue('futureInflated_groceriesAndDiningOutCost', futureValue(values.future_groceriesAndDiningOutCost, ageDifference, (0, _utils.parseFloatCurrencyString)(null, values.groceriesAndEatingOutExpenses)));
    setFieldValue('futureInflated_travelAndEntertainmentCost', futureValue(values.future_travelAndEntertainmentCost, ageDifference, (0, _utils.parseFloatCurrencyString)(null, values.travelAndEntertainmentExpenses)));
    setFieldValue('futureInflated_personalAndMiscellaneousCost', futureValue(values.future_personalAndMiscellaneousCost, ageDifference, (0, _utils.parseFloatCurrencyString)(null, values.personalExpenses)));
  }, [values.future_housingAndInsuranceCost, values.future_healthcareAndInsuranceCost, values.future_transportationAndInsuranceCost, values.future_groceriesAndDiningOutCost, values.future_travelAndEntertainmentCost, values.future_personalAndMiscellaneousCost, values.housingExpenses, values.healthCareAndInsuranceExpenses, values.transportationExpenses, values.groceriesAndEatingOutExpenses, values.travelAndEntertainmentExpenses, values.personalExpenses, values.currentAge, values.retirementAge]);
  function sumFutureExpenses() {
    return 0 + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.futureInflated_housingAndInsuranceCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.futureInflated_healthcareAndInsuranceCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.futureInflated_transportationAndInsuranceCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.futureInflated_groceriesAndDiningOutCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.futureInflated_travelAndEntertainmentCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.futureInflated_personalAndMiscellaneousCost));
  }
  function futureValue(startingValue, years, inflationRate) {
    var numericValue = (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, startingValue)) * (1 + inflationRate / 100) ** years;
    return (0, _utils.numberToCurrencyString)(numericValue, 0, false);
  }

  // Refine Modal handle submit
  var handleSubmit = e => {
    e.preventDefault();
    handleClose();
  };

  // Modal functions and state
  var sumModalValues = expenses => {
    var sum = 0;
    for (var e in expenses) {
      sum += (0, _utils.parseCurrencyString)(null, expenses[e]);
    }
    return sum;
  };

  // -- Housing Modal Handlers --
  var [showHousingModal, setShowHousingModal] = (0, _react.useState)(false);
  var [showHealthcareModal, setShowHealthcareModal] = (0, _react.useState)(false);
  var [showTransportationModal, setShowTransportationModal] = (0, _react.useState)(false);
  var [showGroceriesModal, setShowGroceriesModal] = (0, _react.useState)(false);
  var [showTravelModal, setShowTravelModal] = (0, _react.useState)(false);
  var [showPersonalModal, setShowPersonalModal] = (0, _react.useState)(false);
  var housingHandleClose = () => {
    setValidationData(_RetirementIncomeGapWizardCalcConfig.validationRefinementModal);
    setShowHousingModal(false);
    for (var property in snapshot) {
      setFieldValue(property, snapshot[property], false);
    }
  };
  var housingHandleSubmit = () => {
    var modalFields = [values.housing_mortgageRentCost, values.housing_realEstateTaxes, values.housing_utilitiesLawnMaintenance, values.housing_applianceFurnishings, values.housing_homeownersInsurance, values.housing_hoaFees, values.housing_otherExpenses];
    var total = sumModalValues(modalFields);
    setFieldValue('housingAndInsuranceCost', (0, _utils.numberToString)(total));
    setValidationData(_RetirementIncomeGapWizardCalcConfig.validationRefinementModal);
    setShowHousingModal(false);
  };
  var housingHandleShow = () => {
    (0, _utils.customTealiumEvent)(_RetirementIncomeGapWizardCalc.calcName, 'click', 'itemizeHousingExpenses');
    setValidationData(_RetirementIncomeGapWizardCalc.validationHousingModal);
    setShowHousingModal(true);
    setSnapshot(values);
  };

  //event handlers for healthcare modal
  var healthcareHandleClose = () => {
    setValidationData(_RetirementIncomeGapWizardCalcConfig.validationRefinementModal);
    setShowHealthcareModal(false);
    for (var property in snapshot) {
      setFieldValue(property, snapshot[property], false);
    }
  };
  var healthcareHandleSubmit = () => {
    var modalFields = [values.healthcare_insurancePremium, values.healthcare_medicalServices, values.healthcare_homeHealthCare, values.healthcare_prescriptions, values.healthcare_medicalSupplies, values.healthcare_vitaminsMedicines, values.healthcare_outOfPocketServices, values.healthcare_fitnessGym, values.healthcare_lifeInsurancePremiums, values.healthcare_longTermCarePremiums, values.healthcare_disabilityInsurancePremiums, values.healthcare_otherExpenses];
    var total = sumModalValues(modalFields);
    setFieldValue('healthcareAndInsuranceCost', (0, _utils.numberToString)(total));
    setValidationData(_RetirementIncomeGapWizardCalcConfig.validationRefinementModal);
    setShowHealthcareModal(false);
  };
  var healthcareHandleShow = () => {
    (0, _utils.customTealiumEvent)(_RetirementIncomeGapWizardCalc.calcName, 'click', 'itemizeHealthcareExpenses');
    setValidationData(_RetirementIncomeGapWizardCalc.validationHealthcareModal);
    setShowHealthcareModal(true);
    setSnapshot(values);
  };
  //event handlers for transportation modal
  var transportationHandleClose = () => {
    setValidationData(_RetirementIncomeGapWizardCalcConfig.validationRefinementModal);
    setShowTransportationModal(false);
    for (var property in snapshot) {
      setFieldValue(property, snapshot[property], false);
    }
  };
  var transportationHandleSubmit = () => {
    var modalFields = [values.transportation_automobilePayments, values.transportation_carInsurance, values.transportation_carMaintenance, values.transportation_transport, values.transportation_gas, values.transportation_otherExpenses];
    var total = sumModalValues(modalFields);
    setFieldValue('transportationAndInsuranceCost', (0, _utils.numberToString)(total));
    setValidationData(_RetirementIncomeGapWizardCalcConfig.validationRefinementModal);
    setShowTransportationModal(false);
  };
  var transportationHandleShow = () => {
    (0, _utils.customTealiumEvent)(_RetirementIncomeGapWizardCalc.calcName, 'click', 'itemizeTransportationExpenses');
    setValidationData(_RetirementIncomeGapWizardCalc.validationTransportationModal);
    setShowTransportationModal(true);
    setSnapshot(values);
  };

  // -- Groceries Modal Handlers --
  var groceriesHandleClose = () => {
    setValidationData(_RetirementIncomeGapWizardCalcConfig.validationRefinementModal);
    setShowGroceriesModal(false);
    for (var property in snapshot) {
      setFieldValue(property, snapshot[property], false);
    }
  };
  var groceriesHandleSubmit = () => {
    var modalFields = [values.groceries_groceries, values.groceries_diningOut, values.groceries_subscriptionFoodServices, values.groceries_takeOutDelivery, values.groceries_otherFoodExpenses];
    var total = sumModalValues(modalFields);
    setFieldValue('groceriesAndDiningOutCost', (0, _utils.numberToString)(total));
    setValidationData(_RetirementIncomeGapWizardCalcConfig.validationRefinementModal);
    setShowGroceriesModal(false);
  };
  var groceriesHandleShow = () => {
    (0, _utils.customTealiumEvent)(_RetirementIncomeGapWizardCalc.calcName, 'click', 'itemizeGroceriesExpenses');
    setValidationData(_RetirementIncomeGapWizardCalc.validationGroceriesModal);
    setShowGroceriesModal(true);
    setSnapshot(values);
  };

  // -- Travel & Entertainment Modal Handlers --
  var travelHandleClose = () => {
    setValidationData(_RetirementIncomeGapWizardCalcConfig.validationRefinementModal);
    setShowTravelModal(false);
    for (var property in snapshot) {
      setFieldValue(property, snapshot[property], false);
    }
  };
  var travelHandleSubmit = () => {
    var modalFields = [values.travel_activitiesClubsMemberships, values.travel_moviesShowsEntertainment, values.travel_vacation, values.travel_hotelStays, values.travel_roadTrips, values.travel_otherTravelEntertainmentExpenses];
    var total = sumModalValues(modalFields);
    setFieldValue('travelAndEntertainmentCost', (0, _utils.numberToString)(total));
    setValidationData(_RetirementIncomeGapWizardCalcConfig.validationRefinementModal);
    setShowTravelModal(false);
  };
  var travelHandleShow = () => {
    (0, _utils.customTealiumEvent)(_RetirementIncomeGapWizardCalc.calcName, 'click', 'itemizeTravel&EntertainmentExpenses');
    setValidationData(_RetirementIncomeGapWizardCalc.validationTravelModal);
    setShowTravelModal(true);
    setSnapshot(values);
  };

  // -- Personal & Miscellaneous Modal Handlers --
  var personalHandleClose = () => {
    setValidationData(_RetirementIncomeGapWizardCalcConfig.validationRefinementModal);
    setShowPersonalModal(false);
    for (var property in snapshot) {
      setFieldValue(property, snapshot[property], false);
    }
  };
  var personalHandleSubmit = () => {
    var modalFields = [values.personal_clothing, values.personal_personalCare, values.personal_creditCards, values.personal_fixedLoans, values.personal_giftsToOthers, values.personal_petCare, values.personal_otherPersonalExpenses];
    var total = sumModalValues(modalFields);
    setFieldValue('personalAndMiscellaneousCost', (0, _utils.numberToString)(total));
    setValidationData(_RetirementIncomeGapWizardCalcConfig.validationRefinementModal);
    setShowPersonalModal(false);
  };
  var personalHandleShow = () => {
    (0, _utils.customTealiumEvent)(_RetirementIncomeGapWizardCalc.calcName, 'click', 'itemizePersonal&MiscExpenses');
    setValidationData(_RetirementIncomeGapWizardCalc.validationPersonalModal);
    setShowPersonalModal(true);
    setSnapshot(values);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "xl",
    show: show
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(snapshot),
    title: "Edit your inputs & our assumptions"
  }), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-6 col-sm-12"
  }, /*#__PURE__*/_react.default.createElement("h3", null, "Your Details"), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapModalFormControls.CurrentAge, {
    errors: errors,
    touched: touched,
    values: values
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapModalFormControls.RetirementAge, {
    errors: errors,
    touched: touched,
    values: values
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-6 col-sm-12"
  }, /*#__PURE__*/_react.default.createElement("h3", null, "Monthly Retirement Income"), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapModalFormControls.SocialSecurityBenefit, {
    errors: errors,
    touched: touched,
    values: values
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapModalFormControls.Pension, {
    errors: errors,
    touched: touched,
    values: values
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapModalFormControls.OtherIncome, {
    errors: errors,
    touched: touched,
    values: values
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-6 col-sm-12"
  }, /*#__PURE__*/_react.default.createElement("h3", null, "Current Monthly Expenses "), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapModalFormControls.HousingAndInsurance, {
    onClick: housingHandleShow,
    errors: errors,
    touched: touched,
    values: values
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapModalFormControls.HealthcareAndInsurance, {
    onClick: healthcareHandleShow,
    errors: errors,
    touched: touched,
    values: values
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapModalFormControls.TransportationAndInsurance, {
    onClick: transportationHandleShow,
    errors: errors,
    touched: touched,
    values: values
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapModalFormControls.GroceriesAndDiningOut, {
    onClick: groceriesHandleShow,
    errors: errors,
    touched: touched,
    values: values
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapModalFormControls.TravelAndEntertainment, {
    onClick: travelHandleShow,
    errors: errors,
    touched: touched,
    values: values
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapModalFormControls.PersonalAndMiscellaneous, {
    onClick: personalHandleShow,
    errors: errors,
    touched: touched,
    values: values
  }), /*#__PURE__*/_react.default.createElement("h4", null, "Total Current Monthly Expenses: ".concat((0, _utils.numberToCurrencyString)(currentExpenses)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-6 col-sm-12"
  }, /*#__PURE__*/_react.default.createElement("h3", null, "Future Monthly Expenses", ' ', /*#__PURE__*/_react.default.createElement(_PopoverAndOverlay.PopoverAndOverlay, {
    text: (0, _htmlReactParser.default)(_RetirementIncomeGapWizardCalc.popoverConfig.futureExpenses),
    fieldName: "futureMonthlyExpenses"
  })), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapModalFormControls.FutureHousingAndInsurance, {
    errors: errors,
    touched: touched,
    values: values
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapModalFormControls.FutureHealthcareAndInsurance, {
    errors: errors,
    touched: touched,
    values: values
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapModalFormControls.FutureTransportationAndInsurance, {
    errors: errors,
    touched: touched,
    values: values
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapModalFormControls.FutureGroceriesAndDiningOut, {
    errors: errors,
    touched: touched,
    values: values
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapModalFormControls.FutureTravelAndEntertainment, {
    errors: errors,
    touched: touched,
    values: values
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapModalFormControls.FuturePersonalAndMiscellaneous, {
    errors: errors,
    touched: touched,
    values: values
  }), /*#__PURE__*/_react.default.createElement("h4", {
    className: "word-wrap-break"
  }, "Total Future Monthly Expenses: ".concat((0, _utils.numberToCurrencyString)(futureExpenses))))), /*#__PURE__*/_react.default.createElement("h3", null, "Assumed Rates", ' ', /*#__PURE__*/_react.default.createElement(_PopoverAndOverlay.PopoverAndOverlay, {
    text: (0, _htmlReactParser.default)(_RetirementIncomeGapWizardCalc.popoverConfig.assumedRates),
    fieldName: "futureMonthlyExpenses"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-6 col-sm-12"
  }, /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapModalFormControls.HousingInflation, {
    errors: errors,
    touched: touched,
    values: values
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapModalFormControls.HealthcareInflation, {
    errors: errors,
    touched: touched,
    values: values
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapModalFormControls.TransportationInflation, {
    errors: errors,
    touched: touched,
    values: values
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-6 col-sm-12"
  }, /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapModalFormControls.GroceriesInflation, {
    errors: errors,
    touched: touched,
    values: values
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapModalFormControls.TravelInflation, {
    errors: errors,
    touched: touched,
    values: values
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapModalFormControls.PersonalInflation, {
    errors: errors,
    touched: touched,
    values: values
  })))), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapHousingModal.default, {
    show: showHousingModal,
    handleClose: housingHandleClose,
    snapshot: snapshot,
    housingHandleSubmit: housingHandleSubmit
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapHealthcareModal.default, {
    show: showHealthcareModal,
    handleClose: healthcareHandleClose,
    snapshot: snapshot,
    healthcareHandleSubmit: healthcareHandleSubmit
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapTransportationModal.default, {
    show: showTransportationModal,
    handleClose: transportationHandleClose,
    snapshot: snapshot,
    transportationHandleSubmit: transportationHandleSubmit
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapGroceriesModal.default, {
    show: showGroceriesModal,
    handleClose: groceriesHandleClose,
    snapshot: snapshot,
    groceriesHandleSubmit: groceriesHandleSubmit
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapTravelModal.default, {
    show: showTravelModal,
    handleClose: travelHandleClose,
    snapshot: snapshot,
    travelHandleSubmit: travelHandleSubmit
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapPersonalModal.default, {
    show: showPersonalModal,
    handleClose: personalHandleClose,
    snapshot: snapshot,
    personalHandleSubmit: personalHandleSubmit
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Footer, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
    variant: "link",
    onClick: () => handleClose(snapshot)
  }, "Cancel"), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
    disabled: isSubmitting || !isValid,
    onClick: handleSubmit
  }, "Update"))));
}